import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%","margin-bottom":"50px"} }
const _hoisted_2 = ["viewBox"]
const _hoisted_3 = ["xlink:href", "height", "width"]
const _hoisted_4 = ["points", "onClick"]
const _hoisted_5 = { style: {"margin":"0 auto"} }
const _hoisted_6 = {
  xs3: "",
  style: {"display":"flex"}
}
const _hoisted_7 = {
  xs3: "",
  style: {"display":"flex"}
}
const _hoisted_8 = {
  xs3: "",
  style: {"display":"flex"}
}
const _hoisted_9 = {
  xs3: "",
  style: {"display":"flex"}
}
const _hoisted_10 = {
  xs3: "",
  style: {"display":"flex"}
}
const _hoisted_11 = { style: {"text-align":"center","width":"100%"} }
const _hoisted_12 = { style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%"} }
const _hoisted_13 = ["viewBox"]
const _hoisted_14 = ["xlink:href", "height", "width"]
const _hoisted_15 = {
  xs3: "",
  style: {"display":"flex"}
}
const _hoisted_16 = {
  xs3: "",
  style: {"display":"flex"}
}
const _hoisted_17 = {
  xs3: "",
  style: {"display":"flex"}
}
const _hoisted_18 = {
  xs3: "",
  style: {"display":"flex"}
}
const _hoisted_19 = {
  key: 2,
  class: "text-center"
}
const _hoisted_20 = { class: "bottom-sheet" }
const _hoisted_21 = { class: "remote" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (!_ctx.$vuetify.display.mobile)
        ? (_openBlock(), _createBlock(_component_v_layout, {
            key: 0,
            wrap: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_flex, {
                xs12: "",
                sm5: ""
              }, {
                default: _withCtx(() => [
                  (_ctx.mode != 'GeneralLedger' && _ctx.goBackHistory)
                    ? (_openBlock(), _createBlock(_component_v_btn_back, {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.back()), ["stop"]))
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_1, [
                    (_ctx.document)
                      ? (_openBlock(), _createElementBlock("svg", {
                          key: 0,
                          id: "svg-document-validation-payslip-static",
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "100%",
                          viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                          style: {"position":"absolute","width":"100%","left":"0","top":"0"}
                        }, [
                          _createElementVNode("g", null, [
                            _createElementVNode("image", {
                              id: "svg-image-document-validation-payslip-static",
                              "xlink:href": _ctx.document.signedUrl,
                              x: "0",
                              y: "0",
                              height: `${_ctx.imageHeight}px`,
                              width: `${_ctx.imageWidth}px`
                            }, null, 8, _hoisted_3),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.svgVariants, (variant, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: `coord-${_ctx.document.id}-${index}`
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variant.coordinates, (coord, index2) => {
                                  return (_openBlock(), _createElementBlock("polygon", {
                                    key: `coord-${_ctx.document.id}-${index}-${index2}`,
                                    ref_for: true,
                                    ref: `variants-${index}-${index2}`,
                                    points: _ctx.getPoints(coord),
                                    style: _normalizeStyle(
                                                variant.active
                                                    ? 'fill:rgba(250,250,250,0.5);stroke:lime;stroke-width:1'
                                                    : 'fill:rgba(250,250,250,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                            ),
                                    onClick: _withModifiers(($event: any) => (
                                                variant.active
                                                    ? ''
                                                    : _ctx.showCorrespondingField({
                                                          variant,
                                                          currentIndex: index,
                                                          copyIndex: index2,
                                                      })
                                            ), ["stop"]),
                                    class: _normalizeClass(variant.focus ? 'highlighted' : '')
                                  }, null, 14, _hoisted_4))
                                }), 128))
                              ], 64))
                            }), 128))
                          ])
                        ], 8, _hoisted_2))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              (_ctx.associatedFields.show)
                ? (_openBlock(), _createBlock(_component_v_list, {
                    key: 0,
                    style: _normalizeStyle(_ctx.svgPosition)
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associatedFields.fields, (field, key, index) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: `field-${_ctx.document.id}-${key}-${index}`,
                          onClick: ($event: any) => (_ctx.onFieldAssociation(field, key)),
                          class: "oss-list-item"
                        }, null, 8, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["style"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_flex, {
                xs12: "",
                sm7: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    style: {"position":"fixed","margin-top":"-3vh","max-height":"80vh","overflow-y":"auto"},
                    class: "default_card_wm"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { style: {"padding-bottom":"0","padding-top":"5px"} }, {
                        default: _withCtx(() => [
                          _cache[82] || (_cache[82] = _createElementVNode("h3", null, "Détails", -1)),
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn_icon, {
                            icon: "$cloud_download",
                            color: "secondary",
                            onClick: _ctx.startDownloadFile
                          }, null, 8, ["onClick"]),
                          (_ctx.restartAnalysis)
                            ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                key: 0,
                                icon: "$oss-scan",
                                color: "secondary",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.analyseDocumentDialog = true))
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { style: {"padding-top":"0"} }, {
                        default: _withCtx(() => [
                          (_ctx.form['date'])
                            ? (_openBlock(), _createBlock(_component_v_form, {
                                key: 0,
                                ref: "form",
                                modelValue: _ctx.valid,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.valid) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_flex, { xs12: "" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("div", _hoisted_6, [
                                          _createVNode(_component_v_text_field_filled, {
                                            onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.highlightField(_ctx.form.grossSalary, true))),
                                            onMouseout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.highlightField(_ctx.form.grossSalary, false))),
                                            regular: "",
                                            outlined: "",
                                            class: "mr-1",
                                            "hide-details": true,
                                            readonly: "",
                                            label: "Salarié",
                                            "model-value": 
                                                    _ctx.getUserDisplayName(_ctx.currentAccountUser)
                                                
                                          }, null, 8, ["model-value"])
                                        ])
                                      ]),
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_v_flex, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field_filled, {
                                              onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.highlightField(_ctx.form.grossSalary, true))),
                                              onMouseout: _cache[5] || (_cache[5] = ($event: any) => (_ctx.highlightField(_ctx.form.grossSalary, false))),
                                              regular: "",
                                              outlined: "",
                                              class: "mr-1",
                                              "hide-details": true,
                                              readonly: "",
                                              "model-value": _ctx.formatDate(_ctx.form['date'].value)
                                            }, null, 8, ["model-value"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_text_field_filled, {
                                          onMouseover: _cache[6] || (_cache[6] = ($event: any) => (_ctx.highlightField(_ctx.form.grossSalary, true))),
                                          onMouseout: _cache[7] || (_cache[7] = ($event: any) => (_ctx.highlightField(_ctx.form.grossSalary, false))),
                                          regular: "",
                                          outlined: "",
                                          class: "mr-1",
                                          "hide-details": true,
                                          readonly: "",
                                          "model-value": 
                                                _ctx.newCommonFormatCurrency(
                                                    _ctx.form.grossSalary.value,
                                                    undefined,
                                                )
                                            
                                        }, null, 8, ["model-value"]),
                                        _createElementVNode("div", _hoisted_7, [
                                          _createVNode(_component_v_text_field_filled, {
                                            onMouseover: _cache[8] || (_cache[8] = ($event: any) => (
                                                    _ctx.highlightField(_ctx.form.salaryCharges, true)
                                                )),
                                            onMouseout: _cache[9] || (_cache[9] = ($event: any) => (
                                                    _ctx.highlightField(_ctx.form.salaryCharges, false)
                                                )),
                                            regular: "",
                                            outlined: "",
                                            class: "mr-1",
                                            "hide-details": true,
                                            readonly: "",
                                            "model-value": 
                                                    _ctx.newCommonFormatCurrency(
                                                        _ctx.form.salaryCharges.value,
                                                        undefined,
                                                    )
                                                
                                          }, null, 8, ["model-value"]),
                                          _createVNode(_component_v_text_field_filled, {
                                            onMouseover: _cache[10] || (_cache[10] = ($event: any) => (
                                                    _ctx.highlightField(_ctx.form.employerCharges, true)
                                                )),
                                            onMouseout: _cache[11] || (_cache[11] = ($event: any) => (
                                                    _ctx.highlightField(_ctx.form.employerCharges, false)
                                                )),
                                            regular: "",
                                            outlined: "",
                                            class: "mr-1",
                                            "hide-details": true,
                                            readonly: "",
                                            "model-value": 
                                                    _ctx.newCommonFormatCurrency(
                                                        _ctx.form.employerCharges.value,
                                                        undefined,
                                                    )
                                                
                                          }, null, 8, ["model-value"])
                                        ]),
                                        _createElementVNode("div", _hoisted_8, [
                                          _createVNode(_component_v_text_field_filled, {
                                            onMouseover: _cache[12] || (_cache[12] = ($event: any) => (
                                                    _ctx.highlightField(_ctx.form.nonDeductibleCSGCRDS, true)
                                                )),
                                            onMouseout: _cache[13] || (_cache[13] = ($event: any) => (
                                                    _ctx.highlightField(_ctx.form.nonDeductibleCSGCRDS, false)
                                                )),
                                            regular: "",
                                            outlined: "",
                                            class: "mr-1",
                                            "hide-details": true,
                                            readonly: "",
                                            "model-value": 
                                                    _ctx.newCommonFormatCurrency(
                                                        _ctx.form.nonDeductibleCSGCRDS.value,
                                                        undefined,
                                                    )
                                                
                                          }, null, 8, ["model-value"]),
                                          _createVNode(_component_v_text_field_filled, {
                                            onMouseover: _cache[14] || (_cache[14] = ($event: any) => (_ctx.highlightField(_ctx.form.hshc, true))),
                                            onMouseout: _cache[15] || (_cache[15] = ($event: any) => (_ctx.highlightField(_ctx.form.hshc, false))),
                                            regular: "",
                                            outlined: "",
                                            class: "mr-1",
                                            "hide-details": true,
                                            readonly: "",
                                            "model-value": 
                                                    _ctx.newCommonFormatCurrency(
                                                        _ctx.form.hshc.value,
                                                        undefined,
                                                    )
                                                
                                          }, null, 8, ["model-value"])
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                          _createVNode(_component_v_text_field_filled, {
                                            onMouseover: _cache[16] || (_cache[16] = ($event: any) => (_ctx.highlightField(_ctx.form.navigo, true))),
                                            onMouseout: _cache[17] || (_cache[17] = ($event: any) => (_ctx.highlightField(_ctx.form.navigo, false))),
                                            regular: "",
                                            outlined: "",
                                            class: "mr-1",
                                            "hide-details": true,
                                            readonly: "",
                                            "model-value": 
                                                    _ctx.newCommonFormatCurrency(
                                                        _ctx.form.navigo.value,
                                                        undefined,
                                                    )
                                                
                                          }, null, 8, ["model-value"]),
                                          _createVNode(_component_v_text_field_filled, {
                                            onMouseover: _cache[18] || (_cache[18] = ($event: any) => (
                                                    _ctx.highlightField(_ctx.form.benefitInKind, true)
                                                )),
                                            onMouseout: _cache[19] || (_cache[19] = ($event: any) => (
                                                    _ctx.highlightField(_ctx.form.benefitInKind, false)
                                                )),
                                            regular: "",
                                            outlined: "",
                                            class: "mr-1",
                                            "hide-details": true,
                                            readonly: "",
                                            "model-value": 
                                                    _ctx.newCommonFormatCurrency(
                                                        _ctx.form.benefitInKind.value,
                                                        undefined,
                                                    )
                                                
                                          }, null, 8, ["model-value"]),
                                          _createVNode(_component_v_text_field_filled, {
                                            onMouseover: _cache[20] || (_cache[20] = ($event: any) => (
                                                    _ctx.highlightField(_ctx.form.luncheonVoucher, true)
                                                )),
                                            onMouseout: _cache[21] || (_cache[21] = ($event: any) => (
                                                    _ctx.highlightField(_ctx.form.luncheonVoucher, false)
                                                )),
                                            regular: "",
                                            outlined: "",
                                            class: "mr-1",
                                            "hide-details": true,
                                            readonly: "",
                                            "model-value": 
                                                    _ctx.newCommonFormatCurrency(
                                                        _ctx.form.luncheonVoucher.value,
                                                        undefined,
                                                    )
                                                
                                          }, null, 8, ["model-value"])
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                          _createVNode(_component_v_text_field_filled, {
                                            onMouseover: _cache[22] || (_cache[22] = ($event: any) => (_ctx.highlightField(_ctx.form.employerLoan, true))),
                                            onMouseout: _cache[23] || (_cache[23] = ($event: any) => (_ctx.highlightField(_ctx.form.employerLoan, false))),
                                            regular: "",
                                            outlined: "",
                                            class: "mr-1",
                                            "hide-details": true,
                                            readonly: "",
                                            "model-value": 
                                                    _ctx.newCommonFormatCurrency(
                                                        _ctx.form.employerLoan.value,
                                                        undefined,
                                                    )
                                                
                                          }, null, 8, ["model-value"]),
                                          _createVNode(_component_v_text_field_filled, {
                                            onMouseover: _cache[24] || (_cache[24] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.thirdPartyNotification,
                                                        true,
                                                    )
                                                )),
                                            onMouseout: _cache[25] || (_cache[25] = ($event: any) => (
                                                    _ctx.highlightField(
                                                        _ctx.form.thirdPartyNotification,
                                                        false,
                                                    )
                                                )),
                                            regular: "",
                                            outlined: "",
                                            class: "mr-1",
                                            "hide-details": true,
                                            readonly: "",
                                            "model-value": 
                                                    _ctx.newCommonFormatCurrency(
                                                        _ctx.form.thirdPartyNotification.value,
                                                        undefined,
                                                    )
                                                
                                          }, null, 8, ["model-value"])
                                        ]),
                                        _createVNode(_component_v_text_field_filled, {
                                          onMouseover: _cache[26] || (_cache[26] = ($event: any) => (
                                                _ctx.highlightField(_ctx.form.netSalaryBeforeTax, true)
                                            )),
                                          onMouseout: _cache[27] || (_cache[27] = ($event: any) => (
                                                _ctx.highlightField(_ctx.form.netSalaryBeforeTax, false)
                                            )),
                                          regular: "",
                                          outlined: "",
                                          class: "mr-1",
                                          "hide-details": true,
                                          readonly: "",
                                          "model-value": 
                                                _ctx.newCommonFormatCurrency(
                                                    _ctx.form.netSalaryBeforeTax.value,
                                                    undefined,
                                                )
                                            
                                        }, null, 8, ["model-value"]),
                                        _createVNode(_component_v_text_field_filled, {
                                          onMouseover: _cache[28] || (_cache[28] = ($event: any) => (_ctx.highlightField(_ctx.form.incomeTax, true))),
                                          onMouseout: _cache[29] || (_cache[29] = ($event: any) => (_ctx.highlightField(_ctx.form.incomeTax, false))),
                                          regular: "",
                                          outlined: "",
                                          class: "mr-1",
                                          "hide-details": true,
                                          readonly: "",
                                          "model-value": 
                                                _ctx.newCommonFormatCurrency(
                                                    _ctx.form.incomeTax.value,
                                                    undefined,
                                                )
                                            
                                        }, null, 8, ["model-value"]),
                                        _createVNode(_component_v_text_field_filled, {
                                          onMouseover: _cache[30] || (_cache[30] = ($event: any) => (_ctx.highlightField(_ctx.form.netSalaryPaid, true))),
                                          onMouseout: _cache[31] || (_cache[31] = ($event: any) => (_ctx.highlightField(_ctx.form.netSalaryPaid, false))),
                                          regular: "",
                                          outlined: "",
                                          class: "mr-1",
                                          "hide-details": true,
                                          readonly: "",
                                          "model-value": 
                                                _ctx.newCommonFormatCurrency(
                                                    _ctx.form.netSalaryPaid.value,
                                                    undefined,
                                                )
                                            
                                        }, null, 8, ["model-value"]),
                                        _createVNode(_component_v_text_field_filled, {
                                          onMouseover: _cache[32] || (_cache[32] = ($event: any) => (_ctx.highlightField(_ctx.form.totalCost, true))),
                                          onMouseout: _cache[33] || (_cache[33] = ($event: any) => (_ctx.highlightField(_ctx.form.totalCost, false))),
                                          regular: "",
                                          outlined: "",
                                          class: "mr-1",
                                          "hide-details": true,
                                          readonly: "",
                                          "model-value": 
                                                _ctx.newCommonFormatCurrency(
                                                    _ctx.form.totalCost.value,
                                                    undefined,
                                                )
                                            
                                        }, null, 8, ["model-value"])
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_layout, {
            key: 1,
            wrap: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_flex, {
                xs12: "",
                sm7: "",
                style: {"display":"flex"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_switch, {
                    modelValue: _ctx.showDocument,
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.showDocument) = $event)),
                    "hide-details": "",
                    label: "Afficher le document",
                    class: "my-0 py-0"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_ctx.showDocument)
                ? (_openBlock(), _createBlock(_component_v_flex, {
                    key: 0,
                    xs12: "",
                    sm7: "",
                    onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.showDocument = false))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          (_ctx.document)
                            ? (_openBlock(), _createElementBlock("svg", {
                                key: 0,
                                id: "svg-document-validation-payslip-static",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "100%",
                                viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                                style: {"position":"absolute","width":"100%","left":"0","top":"0"},
                                class: "elevation-2"
                              }, [
                                _createElementVNode("image", {
                                  id: "svg-image-document-validation-payslip-static",
                                  "xlink:href": _ctx.document.signedUrl,
                                  x: "0",
                                  y: "0",
                                  height: `${_ctx.imageHeight}px`,
                                  width: `${_ctx.imageWidth}px`
                                }, null, 8, _hoisted_14)
                              ], 8, _hoisted_13))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_flex, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    onMouseover: _cache[37] || (_cache[37] = ($event: any) => (_ctx.highlightField(_ctx.form.grossSalary, true))),
                    onMouseout: _cache[38] || (_cache[38] = ($event: any) => (_ctx.highlightField(_ctx.form.grossSalary, false))),
                    regular: "",
                    class: "mr-1",
                    "hide-details": true,
                    readonly: "",
                    label: "Salarié",
                    "model-value": _ctx.getUserDisplayName(_ctx.currentAccountUser)
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }),
              _createElementVNode("div", null, [
                _createVNode(_component_v_flex, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      onMouseover: _cache[39] || (_cache[39] = ($event: any) => (_ctx.highlightField(_ctx.form.grossSalary, true))),
                      onMouseout: _cache[40] || (_cache[40] = ($event: any) => (_ctx.highlightField(_ctx.form.grossSalary, false))),
                      regular: "",
                      class: "mr-1",
                      "hide-details": true,
                      readonly: "",
                      "model-value": _ctx.formatDate(_ctx.form['date'].value)
                    }, {
                      label: _withCtx(() => _cache[83] || (_cache[83] = [
                        _createTextVNode(" Date du document ")
                      ])),
                      _: 1
                    }, 8, ["model-value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_text_field, {
                  onMouseover: _cache[41] || (_cache[41] = ($event: any) => (_ctx.highlightField(_ctx.form.grossSalary, true))),
                  onMouseout: _cache[42] || (_cache[42] = ($event: any) => (_ctx.highlightField(_ctx.form.grossSalary, false))),
                  regular: "",
                  class: "mr-1",
                  "hide-details": true,
                  readonly: "",
                  "model-value": _ctx.newCommonFormatCurrency(_ctx.form.grossSalary.value, undefined)
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("document.social.grossSalary")), 1)
                  ]),
                  _: 1
                }, 8, ["model-value"]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_v_text_field, {
                    onMouseover: _cache[43] || (_cache[43] = ($event: any) => (_ctx.highlightField(_ctx.form.salaryCharges, true))),
                    onMouseout: _cache[44] || (_cache[44] = ($event: any) => (_ctx.highlightField(_ctx.form.salaryCharges, false))),
                    regular: "",
                    class: "mr-1",
                    "hide-details": true,
                    readonly: "",
                    "model-value": 
                                _ctx.newCommonFormatCurrency(_ctx.form.salaryCharges.value, undefined)
                            
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("document.social.salaryCharges")), 1)
                    ]),
                    _: 1
                  }, 8, ["model-value"]),
                  _createVNode(_component_v_text_field, {
                    onMouseover: _cache[45] || (_cache[45] = ($event: any) => (_ctx.highlightField(_ctx.form.employerCharges, true))),
                    onMouseout: _cache[46] || (_cache[46] = ($event: any) => (_ctx.highlightField(_ctx.form.employerCharges, false))),
                    regular: "",
                    class: "mr-1",
                    "hide-details": true,
                    readonly: "",
                    "model-value": 
                                _ctx.newCommonFormatCurrency(_ctx.form.employerCharges.value, undefined)
                            
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("document.social.employerCharges")), 1)
                    ]),
                    _: 1
                  }, 8, ["model-value"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_v_text_field, {
                    onMouseover: _cache[47] || (_cache[47] = ($event: any) => (_ctx.highlightField(_ctx.form.nonDeductibleCSGCRDS, true))),
                    onMouseout: _cache[48] || (_cache[48] = ($event: any) => (_ctx.highlightField(_ctx.form.nonDeductibleCSGCRDS, false))),
                    regular: "",
                    class: "mr-1",
                    "hide-details": true,
                    readonly: "",
                    "model-value": 
                                _ctx.newCommonFormatCurrency(_ctx.form.nonDeductibleCSGCRDS.value, undefined)
                            
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("document.social.nonDeductibleCSGCRDS")), 1)
                    ]),
                    _: 1
                  }, 8, ["model-value"]),
                  _createVNode(_component_v_text_field, {
                    onMouseover: _cache[49] || (_cache[49] = ($event: any) => (_ctx.highlightField(_ctx.form.hshc, true))),
                    onMouseout: _cache[50] || (_cache[50] = ($event: any) => (_ctx.highlightField(_ctx.form.hshc, false))),
                    regular: "",
                    class: "mr-1",
                    "hide-details": true,
                    readonly: "",
                    "model-value": _ctx.newCommonFormatCurrency(_ctx.form.hshc.value, undefined)
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("document.social.hshc")), 1)
                    ]),
                    _: 1
                  }, 8, ["model-value"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_v_text_field, {
                    onMouseover: _cache[51] || (_cache[51] = ($event: any) => (_ctx.highlightField(_ctx.form.navigo, true))),
                    onMouseout: _cache[52] || (_cache[52] = ($event: any) => (_ctx.highlightField(_ctx.form.navigo, false))),
                    regular: "",
                    class: "mr-1",
                    "hide-details": true,
                    readonly: "",
                    "model-value": _ctx.newCommonFormatCurrency(_ctx.form.navigo.value, undefined)
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("document.social.navigo")), 1)
                    ]),
                    _: 1
                  }, 8, ["model-value"]),
                  _createVNode(_component_v_text_field, {
                    onMouseover: _cache[53] || (_cache[53] = ($event: any) => (_ctx.highlightField(_ctx.form.benefitInKind, true))),
                    onMouseout: _cache[54] || (_cache[54] = ($event: any) => (_ctx.highlightField(_ctx.form.benefitInKind, false))),
                    regular: "",
                    class: "mr-1",
                    "hide-details": true,
                    readonly: "",
                    "model-value": 
                                _ctx.newCommonFormatCurrency(_ctx.form.benefitInKind.value, undefined)
                            
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("document.social.benefitInKind")), 1)
                    ]),
                    _: 1
                  }, 8, ["model-value"]),
                  _createVNode(_component_v_text_field, {
                    onMouseover: _cache[55] || (_cache[55] = ($event: any) => (_ctx.highlightField(_ctx.form.luncheonVoucher, true))),
                    onMouseout: _cache[56] || (_cache[56] = ($event: any) => (_ctx.highlightField(_ctx.form.luncheonVoucher, false))),
                    regular: "",
                    class: "mr-1",
                    "hide-details": true,
                    readonly: "",
                    "model-value": 
                                _ctx.newCommonFormatCurrency(_ctx.form.luncheonVoucher.value, undefined)
                            
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("document.social.luncheonVoucher")), 1)
                    ]),
                    _: 1
                  }, 8, ["model-value"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_v_text_field, {
                    onMouseover: _cache[57] || (_cache[57] = ($event: any) => (_ctx.highlightField(_ctx.form.employerLoan, true))),
                    onMouseout: _cache[58] || (_cache[58] = ($event: any) => (_ctx.highlightField(_ctx.form.employerLoan, false))),
                    regular: "",
                    class: "mr-1",
                    "hide-details": true,
                    readonly: "",
                    "model-value": 
                                _ctx.newCommonFormatCurrency(_ctx.form.employerLoan.value, undefined)
                            
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("document.social.employerLoan")), 1)
                    ]),
                    _: 1
                  }, 8, ["model-value"]),
                  _createVNode(_component_v_text_field, {
                    onMouseover: _cache[59] || (_cache[59] = ($event: any) => (_ctx.highlightField(_ctx.form.thirdPartyNotification, true))),
                    onMouseout: _cache[60] || (_cache[60] = ($event: any) => (_ctx.highlightField(_ctx.form.thirdPartyNotification, false))),
                    regular: "",
                    class: "mr-1",
                    "hide-details": true,
                    readonly: "",
                    "model-value": 
                                _ctx.newCommonFormatCurrency(
                                    _ctx.form.thirdPartyNotification.value,
                                    undefined,
                                )
                            
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("document.social.thirdPartyNotification")), 1)
                    ]),
                    _: 1
                  }, 8, ["model-value"])
                ]),
                _createVNode(_component_v_text_field, {
                  onMouseover: _cache[61] || (_cache[61] = ($event: any) => (_ctx.highlightField(_ctx.form.netSalaryBeforeTax, true))),
                  onMouseout: _cache[62] || (_cache[62] = ($event: any) => (_ctx.highlightField(_ctx.form.netSalaryBeforeTax, false))),
                  regular: "",
                  class: "mr-1",
                  "hide-details": true,
                  readonly: "",
                  "model-value": 
                            _ctx.newCommonFormatCurrency(_ctx.form.netSalaryBeforeTax.value, undefined)
                        
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("document.social.netSalaryBeforeTax")), 1)
                  ]),
                  _: 1
                }, 8, ["model-value"]),
                _createVNode(_component_v_text_field, {
                  onMouseover: _cache[63] || (_cache[63] = ($event: any) => (_ctx.highlightField(_ctx.form.incomeTax, true))),
                  onMouseout: _cache[64] || (_cache[64] = ($event: any) => (_ctx.highlightField(_ctx.form.incomeTax, false))),
                  regular: "",
                  class: "mr-1",
                  "hide-details": true,
                  readonly: "",
                  "model-value": _ctx.newCommonFormatCurrency(_ctx.form.incomeTax.value, undefined)
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("document.social.incomeTax")), 1)
                  ]),
                  _: 1
                }, 8, ["model-value"]),
                _createVNode(_component_v_text_field, {
                  onMouseover: _cache[65] || (_cache[65] = ($event: any) => (_ctx.highlightField(_ctx.form.netSalaryPaid, true))),
                  onMouseout: _cache[66] || (_cache[66] = ($event: any) => (_ctx.highlightField(_ctx.form.netSalaryPaid, false))),
                  regular: "",
                  class: "mr-1",
                  "hide-details": true,
                  readonly: "",
                  "model-value": _ctx.newCommonFormatCurrency(_ctx.form.netSalaryPaid.value, undefined)
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("document.social.netSalaryPaid")), 1)
                  ]),
                  _: 1
                }, 8, ["model-value"]),
                _createVNode(_component_v_text_field, {
                  onMouseover: _cache[67] || (_cache[67] = ($event: any) => (_ctx.highlightField(_ctx.form.totalCost, true))),
                  onMouseout: _cache[68] || (_cache[68] = ($event: any) => (_ctx.highlightField(_ctx.form.totalCost, false))),
                  regular: "",
                  class: "mr-1",
                  "hide-details": true,
                  readonly: "",
                  "model-value": _ctx.newCommonFormatCurrency(_ctx.form.totalCost.value, undefined)
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("document.social.totalCost")), 1)
                  ]),
                  _: 1
                }, 8, ["model-value"])
              ])
            ]),
            _: 1
          })),
      (!_ctx.$vuetify.display.mobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_v_container, {
                  class: "controller",
                  "elevation-1": "",
                  style: {"pointer-events":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      disabled: _ctx.zoomManager.disableZoomOut(),
                      class: "btn",
                      rounded: "circle",
                      size: "x-small",
                      onClick: _cache[69] || (_cache[69] = _withModifiers(($event: any) => (_ctx.zoomManager.zoomOut()), ["stop"])),
                      icon: "$zoom_out"
                    }, null, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      disabled: _ctx.zoomManager.disableResetZoom(),
                      class: "btn",
                      rounded: "circle",
                      size: "x-small",
                      onClick: _cache[70] || (_cache[70] = _withModifiers(($event: any) => (_ctx.zoomManager.resetZoom()), ["stop"])),
                      icon: "$center_focus_weak"
                    }, null, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      disabled: _ctx.zoomManager.disableZoomIn(),
                      class: "btn",
                      rounded: "circle",
                      size: "x-small",
                      onClick: _cache[71] || (_cache[71] = _withModifiers(($event: any) => (_ctx.zoomManager.zoomIn()), ["stop"])),
                      icon: "$zoom_in"
                    }, null, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      disabled: _ctx.previousDisabled(),
                      class: "btn",
                      rounded: "",
                      size: "small",
                      onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.previous()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[84] || (_cache[84] = [
                            _createTextVNode("$navigate_before")
                          ])),
                          _: 1
                        }),
                        _cache[85] || (_cache[85] = _createElementVNode("span", null, "Précédent", -1))
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    (_ctx.toBeDoneStatus)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          class: "btn",
                          rounded: "circle",
                          size: "x-small",
                          onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.stop())),
                          icon: "$stop"
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_btn, {
                      disabled: _ctx.nextDisabled(),
                      class: "btn",
                      rounded: "",
                      onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.next())),
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _cache[87] || (_cache[87] = _createElementVNode("span", null, "Suivant", -1)),
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[86] || (_cache[86] = [
                            _createTextVNode("$navigate_next")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.openChat)
        ? (_openBlock(), _createBlock(_component_Chat, {
            key: 3,
            id: _ctx.document.chat ? _ctx.document.chat.id : '',
            inShowMessage: _ctx.open_chat,
            chatTitle: 'Document',
            chatSubtitle: _ctx.getChatSubTitle(),
            showSmartChat: _ctx.wishStatus !== 'DENIED',
            onMessageSent: _cache[75] || (_cache[75] = ($event: any) => (_ctx.onMessageSent($event))),
            onShowMessageChanged: _cache[76] || (_cache[76] = ($event: any) => (_ctx.onShowMessageChanged($event)))
          }, null, 8, ["id", "inShowMessage", "chatSubtitle", "showSmartChat"]))
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogChooseDownload,
        "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.dialogChooseDownload) = $event)),
        title: "Télécharger le document",
        width: "80vw"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pr-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    rounded: "",
                    block: "",
                    onClick: _cache[77] || (_cache[77] = ($event: any) => {
                                _ctx.dialogChooseDownload = false;
                                _ctx.downloadFile(true);
                            }),
                    size: "x-large"
                  }, {
                    default: _withCtx(() => _cache[88] || (_cache[88] = [
                      _createTextVNode("Original")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    rounded: "",
                    block: "",
                    onClick: _cache[78] || (_cache[78] = ($event: any) => {
                                _ctx.dialogChooseDownload = false;
                                _ctx.downloadFile(false);
                            }),
                    size: "x-large"
                  }, {
                    default: _withCtx(() => _cache[89] || (_cache[89] = [
                      _createTextVNode("Marqué")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _cache[90] || (_cache[90] = _createTextVNode(" Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté). "))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.analyseDocumentDialog,
        "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.analyseDocumentDialog) = $event)),
        title: "Relancer l'analyse du document",
        onValid: _ctx.analyseDocument,
        width: "800px"
      }, {
        default: _withCtx(() => _cache[91] || (_cache[91] = [
          _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir relancer l'analyse ?", -1)
        ])),
        _: 1
      }, 8, ["modelValue", "onValid"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.deleteDocumentDialog,
        "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.deleteDocumentDialog) = $event)),
        title: "Supprimer le document",
        error: true,
        onValid: _ctx.deleteDocument,
        validTitle: 'Oui je suis sûr(e)',
        validLoading: _ctx.deleteDocumentLoading,
        width: "800px"
      }, {
        default: _withCtx(() => _cache[92] || (_cache[92] = [
          _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer le document ?", -1)
        ])),
        _: 1
      }, 8, ["modelValue", "onValid", "validLoading"])
    ]),
    _: 1
  }))
}